export const RECEIVE_USERS = "users/RECEIVE_USERS";
export const RECEIVE_USER = "users/RECEIVE_USER";
export const REMOVE_USER = "users/REMOVE_USER";
